import React, { useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import { useData } from "../../services/CreateContextServices/CreateContextService";

const Home = () => {
  const { set_true_false } = useData();
  const [ishatade, setside] = useState(true);

  const [isExpanded, setIsExpanded] = useState(true);
  localStorage.setItem("isExpanded", JSON.stringify(isExpanded));

  const handleToggle = () => {

    const newExpandedState = !isExpanded;

    setIsExpanded(!isExpanded);
    setside(!ishatade);
    storeData(!newExpandedState);
  };


  const storeData = (isExpanded: boolean) => {

    set_true_false((prevData) => ({
      ...prevData,
      sharedValue: isExpanded,
    }));

  };
  const rightsideStyle = {
    width: isExpanded ? "calc(100%)" : "calc(100% - 73px)",
    transition: "width 0.1s ease",
    overflow: "scroll",
    height: "100vh"
  };
  return (
    <>
      <section className="sec-i fixsec">
        <div className="mainhome">
          <Sidebar isExpanded={isExpanded} handleToggle={handleToggle} />
          <div style={rightsideStyle}>
            <Outlet context={{ isExpanded }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
